import BaseService from './BaseService';

export default class AccountService extends BaseService {
    // Initializing important variables
    constructor() {
        super();
        this.path = 'account';
    }

    getBalance(details = false) {
        return this.fetch(`${this.domain}/${this.path}/balance?details=${details}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
    getUnpaidInvoices() {
        return this.fetch(`${this.domain}/${this.path}/check-unpaid-invoices`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
    getPrepaidIcomeList(criteria) {
        return this.fetch(`${this.domain}/${this.path}/prepaid-income-list`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
    getHelpDeskUsers() {
        return this.fetch(`${this.domain}/${this.path}/helpdesk-users`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    getUsersWithTheSameEmail(email) {
        return this.fetch(`${this.domain}/${this.path}/users-with-the-same-email/${email}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    getContractTerms() {
        return this.fetch(`${this.domain}/${this.path}/contract-terms-list`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    getContractTermsFile(fileName) {
        return this.fetch(
            `${this.domain}/${this.path}/contract-terms/${fileName}`,
            {
                method: 'GET',
            },
            {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
                'Cache-Control': 'no-cache, no-store, must-revalidate',
                Pragma: 'no-cache',
            }
        ).then((res) => {
            return Promise.resolve(res);
        });
    }

    getSpotPriceList() {
        return this.fetch(`${this.domain}/${this.path}/spot-price-list-v2`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    getAgreementTermFile(fileName) {
        return this.fetch(
            `${this.domain}/${this.path}/agreement-terms-download/${fileName}`,
            {
                method: 'GET',
            },
            {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
                'Cache-Control': 'no-cache, no-store, must-revalidate',
                Pragma: 'no-cache',
            }
        ).then((res) => {
            return Promise.resolve(res);
        });
    }

    isAgreementTermAccepted(agreementTermName) {
        return this.fetch(
            `${this.domain}/${this.path}/agreement-terms/is-accepted/${agreementTermName}`,
        {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    acceptAgreementTerm(agreementTermName) {
        return this.fetch(
            `${this.domain}/${this.path}/agreement-terms/accept/${agreementTermName}`,
        {
            method: 'POST',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
    downloadAgreementPdf(petraFileId, invoiceNumber, invoiceDate) {
        return this.fetch(
            `${this.domain}/${this.path}/download-pdf`,
            {
                method: 'POST',
                body: JSON.stringify({petraFileId, invoiceNumber, invoiceDate}),
            },
            {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
                'Cache-Control': 'no-cache, no-store, must-revalidate',
                Pragma: 'no-cache',
            }
        ).then((res) => {
            return Promise.resolve(res);
        });
    }
    acceptHybridCardUserApproval(agreementTermName) {
        return this.fetch(
            `${this.domain}/${this.path}/hybrid-card-user/agreement-terms/accept/${agreementTermName}`,
        {
            method: 'POST',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

}
